import { FInter, FlexBox, Colors, MagicBox, BrgButton, MEDIA } from "@brg/ui";
import { RectangularButton, RectangularButtonFilled, RectangularButtonHollow } from "shared/components/buttons";
import { SearchBarHolder } from "shared/components/projectsSearchBar/style";
import { TextBarWrapper } from "shared/components/TagsTextBar/TagsTextBar";
import styled, { css } from "styled-components";
import { CoreContainer, LayoutConst } from "../../../core";
import { ShowMoreContent } from "../designer/styles";
import { SlideNavigationWrapperItem } from "../../components/slideNavigation/styles";
import { createGlobalStyle } from "styled-components";
import { Link } from "react-router-dom";

export const OuterWrapper = styled(FlexBox) <{ disableOffset?: boolean }>`
  margin-top: 24px;


  ${SearchBarHolder} {
    max-width: initial !important;
    width: auto !important;
  }

  ${TextBarWrapper} {
    white-space: nowrap;
    margin-right: 43px;
    //height: 47px;
  }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    margin-top: 24px;
  }

  ${p => p.disableOffset ? css`
    margin-top: 0 !important;
  ` : null};
`;

export const Description = styled.div<{ isOnlines?: boolean, preLine?: boolean, isChannel?: boolean }>`
  font-family: 'Inter';
  width: 100%;
  display: block;
  max-width: 858px;

  a {
    color: ${({ theme }) => theme.link.default};
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    font-style: normal;
    transition: color 0.2s;
    cursor: pointer;

    @media ${MEDIA.TABLET} {
      font-size: 17px;
      line-height: 22px;
      letter-spacing: 0.02px;
    }

    &:hover {
      color: ${({ theme }) => theme.link.hover};
      transition: color 0.2s;
    }
  }

  color: ${({ theme }) => theme.app.text};

  ${({ preLine }) => preLine ? css`
    white-space: pre-line;
  ` : null}


  ${p => p?.isOnlines ? css`
    font-weight: 500;
    font-style: normal;
    color: rgba(0, 0, 0, 1);
    font-family: Montserrat !important;
    letter-spacing: -0.02px;
    line-height: 24px;
    font-size: 20px;

  ` : null}

  ${({ isChannel }) =>
    isChannel &&
    css`
      color: ${Colors.zel};
      font-weight: 600;
      font-size: 17px;
      line-height: 22px;

      @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;

        a {
          font-size: 15px;
          line-height: 20px;
        }
      }
    `}
`;

export const DescriptionExtra = styled(Description)`
  margin-bottom: 40px;
  max-width: initial;

   @media (max-width: ${LayoutConst.screen.md}px) {
       margin-top: 5px;
      }
   @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 8px;
      }
`;

export const DescriptionWrapper = styled(FlexBox) <{ disableOffset?: boolean, hideMore?: boolean, isSuperPuper?: boolean }>`
  font-size: 20px;
  line-height: 28px;
  width: 100%;
  flex: 1;

  color: ${({ theme }) => theme.app.text};

  &:not(:first-child) {
     margin-top: 24px;

     @media (max-width: ${LayoutConst.screen.l}px) {
        margin-top: 16px;
     }
  }

  ${({ hideMore }) => hideMore ? css`
    ${ShowMoreContent} {
      display: none;
    }
  ` : null};


  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    letter-spacing: 0.02px;
    
    span {
      font-size: 17px;
      line-height: 22px;
      font-weight: 400;
      letter-spacing: 0.02px;
    }
  }

  ${({ isSuperPuper }) => isSuperPuper && css`
    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        letter-spacing: 0.02px;
      }
`};

 @media ${MEDIA.MOBILE} {
    font-size: 15px;
    line-height: 20px;
    
    span {
      font-size: 15px;
      line-height: 20px;
    }
  }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    width: 100%;
    display: block;
    position: relative;
    overflow-x: auto;

    ${ShowMoreContent} {
      display: flex;
    }
  }
`

export const ProjectControllerWrapper = styled(FlexBox) <{ isTeamRoute?: boolean }>`
  margin-top: 24px;
  margin-bottom: ${({ isTeamRoute }) => isTeamRoute ? '24px' : '48px'};

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-top: 16px;
    margin-bottom: ${({ isTeamRoute }) => isTeamRoute ? '16px' : '48px'};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-bottom: ${({ isTeamRoute }) => isTeamRoute ? '8px' : '48px'};
  }
`

export const ButtonWrapper = styled(FlexBox) <{ hasEmblem?: boolean, fs?: boolean, buttonsWrap?: boolean, isMainPage?: boolean, isLms?: boolean, isMedia?: boolean, emblemVisible?: boolean, isFashionDeziiign?: boolean, buttonsQuantity?: number }>`

  gap: ${LayoutConst.projectCardGap.l + 'px'};
  max-width: 858px;

  .button-outer {
    min-width: ${LayoutConst.showcaseButton.l}px;
    max-width: ${p => p.buttonsQuantity && p.buttonsQuantity > 2? LayoutConst.showcaseButton.l + 'px' : 'fit-content'};
    width: ${p => p.buttonsQuantity && p.buttonsQuantity > 2? LayoutConst.showcaseButton.l + 'px' : 'fit-content'};
    ${({ isMedia }) => isMedia && 'margin-top: 24px;'};

    @media(max-width: ${LayoutConst.screen.l}px) {
      ${({ buttonsWrap, hasEmblem, buttonsQuantity }) => css`
        width: ${buttonsQuantity && buttonsQuantity > 2? LayoutConst.showcaseButton.m + 'px' : '100%'};
        max-width: ${buttonsQuantity  && buttonsQuantity > 2? LayoutConst.showcaseButton.m + 'px' : '100%'};
        min-width: ${LayoutConst.showcaseButton.m + 'px'};
      `};
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
    }
  };

  @media(max-width: ${LayoutConst.screen.l}px) {
    gap: ${LayoutConst.projectCardGap.tablet + 'px'};
  }

  ${({ buttonsWrap }) => buttonsWrap ? css`
    @media (max-width: ${LayoutConst.screen.l}px) {
      order: 2;
      width: 100%;
      height: auto;
      place-items: flex-start;
      flex-wrap: wrap;
    }
  ` : null};

  @media ${MEDIA.MOBILE} {
    gap: ${LayoutConst.projectCardGap.s + 'px'};
    order: 2;
    width: 100%;
    height: auto;
    place-items: center;
    // flex-flow: ${({ hasEmblem }) => hasEmblem ? 'column' : 'row'};
    justify-content: flex-end;
    flex-wrap: ${({ hasEmblem }) => hasEmblem ? 'nowrap' : 'wrap'};
    flex-flow: column;
  }
`;

export const BottomOuterContainer = styled(FlexBox) <{ disabledMobOffset?: boolean, disableGap?: boolean, isLMSTeam?: boolean, disabledOffset?: boolean, isGalllleryBooks?: boolean, disabledTabs?: boolean, align?: string, visibleMobileTabs?: boolean, hide?: boolean, isChannel?: boolean, teamButtons?: boolean, mediaShowcaseStyles?: CSSProperties }>`
  align-items: ${({ align }) => align ? align : 'flex-end'};
  margin-top: ${({ disabledOffset }) => disabledOffset ? '0px' : '24px'};

  ${({ mediaShowcaseStyles }) => mediaShowcaseStyles ? mediaShowcaseStyles : null};

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-top: 16px;
  }

  ${({ disabledTabs }) => disabledTabs ? css`
    .action-buttons {
      display: none;
    }
  ` : css`
    .action-buttons {
      margin-top: 0;
    }
  `};
  
  @media (max-width: ${LayoutConst.screen.md}px) {
    align-items: ${({ align }) => align ? align : 'flex-start'};

    ${({ visibleMobileTabs }) => visibleMobileTabs ? css`
      align-items: flex-start;
    ` : null};
  }  
  
  @media (max-width: 834px) {
    flex-direction: column;
    gap: ${({ disableGap, isLMSTeam }) => isLMSTeam ? '24px' : disableGap ? 0 : '24px'};
    align-items: flex-start;

    ${({ disabledTabs, teamButtons }) => disabledTabs ? css`
    .action-buttons {
      display: flex;
      margin-top: ${teamButtons ? '0px' : '0'};
    }
  ` : css`
    .action-buttons {
      margin-top: ${teamButtons ? '0px' : '0'};
    }
  `};

    // .search-bar-wrapper {
    //   place-items: flex-end;
    // }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    gap: ${({ disableGap }) => disableGap ? 0 : '24px'};
    // margin-top: 16px !important;
  }

  @media(max-width: 430px) {
    ${({ disabledMobOffset, hide }) => disabledMobOffset ? css`
    margin-top: 0;
    ` : hide ? css` display: none` : null}
  }
`

export const AdditionalTitleWrapper = styled.span`
  color: ${Colors.galBlack47};
  margin-left: 32px;
  @media (max-width: ${LayoutConst.screen.sm}px) {
    margin-left: 16px;
  }
`

export const SearchBarBox = styled(FlexBox)<{isTab?: boolean}>`
    ${({ isTab }) => isTab ? css`
      margin-left: auto;
  ` : null};
    @media(max-width: ${LayoutConst.screen.s}px) {
      width: 100%;
      justify-content: flex-end;
    }

`

export const BottomGroupWrapper = styled(FlexBox) <{ titleIsTabs?: boolean, disableOffset?: boolean, disabledTabs?: boolean, disableButtons?: boolean, justifyBetween?: boolean, hasEmblem?: boolean, isAgeytomesh?: boolean, isMedia?: boolean, isCGRave?: boolean, teamButtons?: boolean }>`
  flex-direction: column;
  &:empty {
    display: none;
  }
  max-width: ${({ hasEmblem }) => (hasEmblem) ? '100%' : `calc(100% - ${LayoutConst.projectCard.l.w}px - 24px)`};

   &:not(:first-child) {
     margin-top: 24px;
    //  margin-bottom: 24px;

     @media (max-width: ${LayoutConst.screen.l}px) {
        max-width: 100%;
        margin-top: 16px;
     }
  }

  ${({ hasEmblem }) => hasEmblem ? css`
    justify-content: space-between;
    height: 100%;
  ` : null};

  ${({ disabledTabs, teamButtons }) => disabledTabs ? css`
    .slide-navigation {
      display: none;
    }

    .action-buttons {
      margin-top: ${teamButtons ? '16px' : '0'};
    }
  ` : css`
    .action-buttons {
      margin-top: ${teamButtons ? '16px' : '0'};
    }
  `};

  ${({ disableButtons }) => disableButtons ? css`
    .action-buttons {
      display: none;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      .action-buttons {
        display: flex;
      }
    }
  ` : null};


  ${({ titleIsTabs }) => titleIsTabs ? css`
    // flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    place-items: baseline;
    ${SearchBarBox} {
      flex-direction: column;
      gap: 12px;
      align-items: flex-end;
      ${TextBarWrapper} {
        margin-right: 0;
      }
    }
    ${DescriptionWrapper} {
      max-width: 858px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
      ${DescriptionWrapper} {
        max-width: 714px;
      }
    }

    @media (max-width:  ${LayoutConst.screen.md}px) {
      flex-direction: column;
      ${SearchBarBox} {
        flex-direction: inherit;
        gap: initial;
        align-items: inherit;
        justify-content: space-between;
        ${TextBarWrapper} {
          margin-right: inherit;
        }
      }
      ${DescriptionWrapper} {
        max-width: initial;
      }
      ${OuterWrapper} {
        width: 100%;
      }
    }
    
  `: null}

  @media(max-width: ${LayoutConst.screen.l}px) {
    ${({ isAgeytomesh }) => isAgeytomesh ? css`
      max-width: 700px;
    ` : css`
      max-width: 100%;
    `};
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    ${({ disabledTabs }) => disabledTabs ? css`
    .slide-navigation {
      display: flex;
    }
  ` : null};

    max-width: ${({ hasEmblem }) => hasEmblem ? '100%' : `100%`};
  }

    ${({ justifyBetween }) => justifyBetween ? css`
      @media(max-width: ${LayoutConst.screen.m}px) {
        justify-content: space-between !important;
        height: 100%;

        .slide-navigation {
          display: none;
        }
      }
    ` : null};
`

export const BrndButtonsWrapper = styled.div`
    display: flex;
    margin-top: 24px;
`

export const ExploreButtonFilled = styled(RectangularButtonFilled) <{
  isGreenBG?: boolean,
  isOrangeBG?: boolean,
  isBlueBG?: boolean,
  isAgeytomesh?: boolean,
  isTeamLG?: boolean,
  customBG?: string,
  disableOffset?: boolean
}>`
  max-width: ${LayoutConst.projectCard.l.w + 'px'};
  min-width: ${LayoutConst.projectCard.l.w + 'px'} !important;
  width: ${LayoutConst.projectCard.l.w + 'px'};
  max-height: 46px;
  white-space: pre;
  // margin-right: ${LayoutConst.projectCardGap.l + 'px'}!important;
  // color: #FEFEFE!important;


  ${({ isTeamLG }) => isTeamLG ? css`
    color: #151514 !important;
  ` : null};

  //Для агейтомеша
  ${({ isGreenBG, isOrangeBG, customBG }) => customBG ? css`background-color: ${customBG} !important;` : isGreenBG ? css`background-color: #151514 !important;` : isOrangeBG ? css`background-color: rgba(231, 87, 40, 1) !important;` : null};

  @media (max-width:  ${LayoutConst.screen.l}px) {
    max-width: ${LayoutConst.projectCard.m.w + 'px'};
    min-width: ${LayoutConst.projectCard.m.w + 'px'} !important;
    width: ${LayoutConst.projectCard.m.w + 'px'};
    // margin-right: ${LayoutConst.projectCardGap.m + 'px'}!important;
  }
  
  @media (max-width:  ${LayoutConst.screen.m}px) {
    max-width: ${LayoutConst.projectCard.s.w + 'px'};
    min-width: ${LayoutConst.projectCard.s.w + 'px'} !important;
    width: ${LayoutConst.projectCard.s.w + 'px'};
    // margin-right: ${LayoutConst.projectCardGap.s + 'px'}!important;

    ${({ isGreenBG, isOrangeBG, customBG }) => customBG ? css`background-color: ${customBG} !important;` : isGreenBG ? css`background-color: #0DC143 !important;` : isOrangeBG ? css`background-color: rgba(231, 87, 40, 1) !important;` : null};

  }
  
  @media (max-width:  ${LayoutConst.screen.s}px) {
    max-width: 145px;
    min-width: 145px!important;
    width: 145px;
  }
`
export const ExploreButtonHollow = styled(RectangularButtonHollow) <{ disableOffset?: boolean }>`
  max-width: ${LayoutConst.projectCard.l.w + 'px'};
  min-width: ${LayoutConst.projectCard.l.w + 'px'} !important;
  width: ${LayoutConst.projectCard.l.w + 'px'};
  max-height: 46px;
  white-space: pre;
  // margin-right: ${LayoutConst.projectCardGap.l + 'px'}!important;

  @media (max-width:  ${LayoutConst.screen.l}px) {
    max-width: ${LayoutConst.projectCard.m.w + 'px'};
    min-width: ${LayoutConst.projectCard.m.w + 'px'} !important;
    width: ${LayoutConst.projectCard.m.w + 'px'};
    // margin-right: ${LayoutConst.projectCardGap.m + 'px'}!important;
  }
  
  @media (max-width:  ${LayoutConst.screen.m}px) {
    max-width: ${LayoutConst.projectCard.s.w + 'px'};
    min-width: ${LayoutConst.projectCard.s.w + 'px'} !important;
    width: ${LayoutConst.projectCard.s.w + 'px'};
    // margin-right: ${LayoutConst.projectCardGap.s + 'px'}!important;
  }
  
  @media (max-width:  ${LayoutConst.screen.s}px) {
    max-width: 145px;
    min-width: 145px!important;
    width: 145px;
  }
`

export const EditChannelButton = styled(ExploreButtonHollow)`
   font-size: 15px!important;
  line-height: 20px!important;
  font-weight: 600!important;
  height: 40px!important;

  @media (max-width:  ${LayoutConst.screen.s}px) {
    max-width: 170px;
    min-width: 170px!important;
    width: 170px;
  }
`

export const AdaptiveTitleContainer = styled(MagicBox) <{ isAgeyTomesh?: boolean, isGeograffee?: boolean, isSuperPuper?: boolean, isGalllleryArt?: boolean }>`
    margin-bottom: 8px;
    text-transform: ${({ isGalllleryArt }) => isGalllleryArt ? 'uppercase' : 'lowercase'};
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
    line-height: 64px;
    letter-spacing: -0.02em;

    ${({ isGeograffee }) => isGeograffee && css`
      @media (max-width:  ${LayoutConst.screen.m}px) {
      color: #fefefe;
      }
    `};

    ${({ isAgeyTomesh }) => isAgeyTomesh && css`
      text-transform: uppercase;
      font-size: 60px;
      line-height: 64px;
      letter-spacing: 0.53em;
      font-weight: 600;

      @media (max-width:  ${LayoutConst.screen.l}px) {
        font-size: 43px !important;
        line-height: 51px !important;
        letter-spacing: 0.53em !important;
        font-weight: 600 !important;
      }

      @media (max-width: ${LayoutConst.screen.m_1024}px) {
        font-size: 43px !important;
        line-height: 51px !important;
        letter-spacing: 0.53em !important;
        font-weight: 600 !important;
      }

      @media (max-width:  ${LayoutConst.screen.m}px) {
        font-size: 43px !important;
        line-height: 51px !important;
        letter-spacing: 0.30em !important;
        font-weight: 600 !important;
      }

      @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 43px !important;
        line-height: 51px !important;
        letter-spacing: 0.30em !important;
        font-weight: 600 !important;
      }

      @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 28px !important;
        line-height: 34px !important;
        letter-spacing: 0.15em !important;
        font-weight: 600 !important;
      }
    `};
    ${({ isSuperPuper }) => isSuperPuper && css`
      @media (max-width:  ${LayoutConst.screen.m}px) {
          font-size: 43px !important;
          line-height: 51px !important;
          letter-spacing: 1.5px !important;
          font-weight: 600 !important;
          max-width: 350px;
          margin-bottom: 11px;
        }
        `}
    @media (max-width:  ${LayoutConst.screen.l}px) {
      // letter-spacing: 0.53em;
      letter-spacing: -0.02em;
    }

    @media (max-width:  ${LayoutConst.screen.m}px) {
      font-weight: 700;
      font-size: 43px;
      line-height: 51px;
      margin-bottom: 16px;
    }
    @media (max-width:  ${LayoutConst.screen.s}px) { 
      width: 500px; 
      font-size: 43px;
      line-height: 51px;
      letter-spacing: normal !important; 
      margin-bottom: 8px; 
    }

    @media (max-width:  ${LayoutConst.screen.s - 1}px) {
      font-size: 28px;
      line-height: 34px;
      letter-spacing: 4.8px;
      margin-bottom: 8px;
      ${({ isGalllleryArt }) => isGalllleryArt && css`
        letter-spacing: 7.8px !important; 
      `}
    }      
  
    span {
        color: inherit;
    }
`

export const SlideNavigationWrapperItemCustomLink = styled(SlideNavigationWrapperItem) <{ isLMSCourse?: boolean, isTeamLink?: boolean }>`
  // margin-left: 32px;
  min-height: 20px;
  margin-right: ${({ isLMSCourse }) => !isLMSCourse ? '16px !important' : '0px'};
  flex-shrink: 0;

  #tooltip-parent-element , .tooltip-parent-element {
    &::after, &::before {
      display: none !important;
    }
    background: #CDCDCD;
    border-radius: 6px;
    color: #70706F;
  }

  .shop-link-svg {
    height: 20px;
  }
  
  .team-link-svg {
    height: 28px;
    outline: none;
    border: none;
    path {
      transition: fill 0.2s;
    }
    rect {
      transition: stroke 0.2s;
    }

    &:hover {
      path {
        fill: #545453;
        transition: fill 0.2s;
      }
      rect {
        stroke: #545453;
        transition: stroke 0.2s;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    padding: 0px;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-left: ${({ isTeamLink }) => isTeamLink ? 0 : '16px'};
    align-items: center;
    margin-bottom: 0;
    padding-bottom: 0;

    .shop-link-svg {
      height: 14px;
    }
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    min-height: unset;
    margin-bottom: ${({ isTeamLink }) => isTeamLink ? 0 : '3px'};
    margin-left: 0;
    padding: 0;
  }
`

export const DesignerLink = styled(Link) <{ isChannel?: boolean }>`
    color: ${Colors.galBlack47};
    cursor: pointer;
    font-family: Inter;
    font-weight: 600;

    ${({ isChannel }) =>
    isChannel &&
    css`
      font-size: 17px;
      line-height: 22px;

      @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
      }
    `}

    &:hover {
        text-decoration: none;
        color: ${(p) => p.theme.projectView.titleColor};
    }
`;


export const BrndTitle = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0;
  font-size: 60px;
  line-height: 70px;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 50px;
    line-height: 60px;
  }
  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 43px;
    line-height: 51px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 43px;
    line-height: 51px;
  }
   @media (max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 28px;
            line-height: 34px;
            letter-spacing: -0.56px;
        }
`

export const IFrameGlobal = createGlobalStyle`
  #navbar {
    display: none !important;
  }
  #footer-portal {
    display: none !important;
  }
  #app-content {
    > div {
      display: none;
    }
    padding: 0px;
  }
  #map-frame-wrapper {
    height: 100%;
  }
  
`

export const Outer = styled(CoreContainer) <{ isCompetition?: boolean, minOffset?: boolean, isHse?: boolean }>`
  position: relative;
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: ${({ minOffset }) => minOffset ? 0 : '20px'};
    padding-left: 10px;
    padding-right: 10px;
  }

  ${({ isCompetition, minOffset }) => isCompetition ? css`
    @media(max-width: ${LayoutConst.screen.md}px) {
      .target-icon-wrapper {
        * {
          color: #fefefe;
          font-weight: 500;
        }
      }
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
      margin-top: ${minOffset ? 0 : '16px'};
    }
  ` : null};



`;

export const GlobalChangeColorWrapper = createGlobalStyle`
  .app-wrapper {
    background-color: #E7E7E7!important;
  }
`

export const Title = styled(FInter.MainTitleMediumDiv)`
  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 36px;
    line-height: 39px;
  }
`;

export const MobileFilterRow = styled.div<{ fixed?: boolean, importantWidth?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  ${(p) =>
          p?.fixed ? css`
            position: sticky;
            top: 48px;
            left: 0;
            width: auto;
            z-index: 99;
            background-color: ${p => p.theme.app.backgroundColor};
          ` : null}

  ${p => p.importantWidth ? css`
    width: 100%;
  ` : css`
    .ExploreViewInnerSearchTags {
      width: calc(100% - 100px);
    }
  `};
  @media (max-width: 743px) {
    width: 100%;
  }
`;

export const MobileFilterSort = styled.div<{isLectureMedia?: boolean}>`
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #909090;
  display: flex;
  align-items: center;

  ${({isLectureMedia}) => isLectureMedia && css`
    width: 145px;
    justify-content: flex-end;
  `}


  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 15px;
    line-height: 20px;
    margin-left: auto;
    align-self: flex-start;
    margin-right: 10px;
  }
`;import { FInter, FlexBox, Colors, MagicBox, BrgButton, MEDIA } from "@brg/ui";
import { RectangularButton, RectangularButtonFilled, RectangularButtonHollow } from "shared/components/buttons";
import { SearchBarHolder } from "shared/components/projectsSearchBar/style";
import { TextBarWrapper } from "shared/components/TagsTextBar/TagsTextBar";
import styled, { css } from "styled-components";
import { CoreContainer, LayoutConst } from "../../../core";
import { ShowMoreContent } from "../designer/styles";
import { SlideNavigationWrapperItem } from "../../components/slideNavigation/styles";
import { createGlobalStyle } from "styled-components";
import { Link } from "react-router-dom";

export const OuterWrapper = styled(FlexBox) <{ disableOffset?: boolean }>`
  margin-top: 24px;


  ${SearchBarHolder} {
    max-width: initial !important;
    width: auto !important;
  }

  ${TextBarWrapper} {
    white-space: nowrap;
    margin-right: 43px;
    //height: 47px;
  }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    margin-top: 24px;
  }

  ${p => p.disableOffset ? css`
    margin-top: 0 !important;
  ` : null};
`;

export const Description = styled.div<{ isOnlines?: boolean, preLine?: boolean, isChannel?: boolean }>`
  font-family: 'Inter';
  width: 100%;
  display: block;
  max-width: 858px;

  a {
    color: ${({ theme }) => theme.link.default};
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    font-style: normal;
    transition: color 0.2s;
    cursor: pointer;

    @media ${MEDIA.TABLET} {
      font-size: 17px;
      line-height: 22px;
      letter-spacing: 0.02px;
    }

    &:hover {
      color: ${({ theme }) => theme.link.hover};
      transition: color 0.2s;
    }
  }

  color: ${({ theme }) => theme.app.text};

  ${({ preLine }) => preLine ? css`
    white-space: pre-line;
  ` : null}


  ${p => p?.isOnlines ? css`
    font-weight: 500;
    font-style: normal;
    color: rgba(0, 0, 0, 1);
    font-family: Montserrat !important;
    letter-spacing: -0.02px;
    line-height: 24px;
    font-size: 20px;

  ` : null}

  ${({ isChannel }) =>
    isChannel &&
    css`
      color: ${Colors.zel};
      font-weight: 600;
      font-size: 17px;
      line-height: 22px;

      @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;

        a {
          font-size: 15px;
          line-height: 20px;
        }
      }
    `}
`;

export const DescriptionExtra = styled(Description)`
  margin-bottom: 40px;
  max-width: initial;

   @media (max-width: ${LayoutConst.screen.md}px) {
       margin-top: 5px;
      }
   @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 8px;
      }
`;

export const DescriptionWrapper = styled(FlexBox) <{ disableOffset?: boolean, hideMore?: boolean, isSuperPuper?: boolean }>`
  font-size: 20px;
  line-height: 28px;
  width: 100%;
  flex: 1;

  color: ${({ theme }) => theme.app.text};

  &:not(:first-child) {
     margin-top: 24px;

     @media (max-width: ${LayoutConst.screen.l}px) {
        margin-top: 16px;
     }
  }

  ${({ hideMore }) => hideMore ? css`
    ${ShowMoreContent} {
      display: none;
    }
  ` : null};


  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    letter-spacing: 0.02px;
    
    span {
      font-size: 17px;
      line-height: 22px;
      font-weight: 400;
      letter-spacing: 0.02px;
    }
  }

  ${({ isSuperPuper }) => isSuperPuper && css`
    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 17px;
        line-height: 22px;
        font-weight: 400;
        letter-spacing: 0.02px;
      }
`};

 @media ${MEDIA.MOBILE} {
    font-size: 15px;
    line-height: 20px;
    
    span {
      font-size: 15px;
      line-height: 20px;
    }
  }

  @media (max-width: ${LayoutConst.screen.sm}px) {
    width: 100%;
    display: block;
    position: relative;
    overflow-x: auto;

    ${ShowMoreContent} {
      display: flex;
    }
  }
`

export const ProjectControllerWrapper = styled(FlexBox) <{ isTeamRoute?: boolean }>`
  margin-top: 24px;
  margin-bottom: ${({ isTeamRoute }) => isTeamRoute ? '24px' : '48px'};

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-top: 16px;
    margin-bottom: ${({ isTeamRoute }) => isTeamRoute ? '16px' : '48px'};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-bottom: ${({ isTeamRoute }) => isTeamRoute ? '8px' : '48px'};
  }
`

export const ButtonWrapper = styled(FlexBox) <{ hasEmblem?: boolean, fs?: boolean, buttonsWrap?: boolean, isMainPage?: boolean, isLms?: boolean, isMedia?: boolean, emblemVisible?: boolean, isFashionDeziiign?: boolean, buttonsQuantity?: number }>`

  gap: ${LayoutConst.projectCardGap.l + 'px'};
  max-width: 858px;

  .button-outer {
    min-width: ${LayoutConst.showcaseButton.l}px;
    max-width: ${p => p.buttonsQuantity && p.buttonsQuantity > 2? LayoutConst.showcaseButton.l + 'px' : 'fit-content'};
    width: ${p => p.buttonsQuantity && p.buttonsQuantity > 2? LayoutConst.showcaseButton.l + 'px' : 'fit-content'};
    ${({ isMedia }) => isMedia && 'margin-top: 24px;'};

    @media(max-width: ${LayoutConst.screen.l}px) {
      ${({ buttonsWrap, hasEmblem, buttonsQuantity }) => css`
        width: ${buttonsQuantity && buttonsQuantity > 2? LayoutConst.showcaseButton.m + 'px' : '100%'};
        max-width: ${buttonsQuantity  && buttonsQuantity > 2? LayoutConst.showcaseButton.m + 'px' : '100%'};
        min-width: ${LayoutConst.showcaseButton.m + 'px'};
      `};
    }

    @media (max-width: ${LayoutConst.screen.s - 1}px) {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
    }
  };

  @media(max-width: ${LayoutConst.screen.l}px) {
    gap: ${LayoutConst.projectCardGap.tablet + 'px'};
  }

  ${({ buttonsWrap }) => buttonsWrap ? css`
    @media (max-width: ${LayoutConst.screen.l}px) {
      order: 2;
      width: 100%;
      height: auto;
      place-items: flex-start;
      flex-wrap: wrap;
    }
  ` : null};

  @media ${MEDIA.MOBILE} {
    gap: ${LayoutConst.projectCardGap.s + 'px'};
    order: 2;
    width: 100%;
    height: auto;
    place-items: center;
    // flex-flow: ${({ hasEmblem }) => hasEmblem ? 'column' : 'row'};
    justify-content: flex-end;
    flex-wrap: ${({ hasEmblem }) => hasEmblem ? 'nowrap' : 'wrap'};
    flex-flow: column;
  }
`;

export const BottomOuterContainer = styled(FlexBox) <{ disabledMobOffset?: boolean, disableGap?: boolean, isLMSTeam?: boolean, disabledOffset?: boolean, isGalllleryBooks?: boolean, disabledTabs?: boolean, align?: string, visibleMobileTabs?: boolean, hide?: boolean, isChannel?: boolean, teamButtons?: boolean, mediaShowcaseStyles?: CSSProperties }>`
  align-items: ${({ align }) => align ? align : 'flex-end'};
  margin-top: ${({ disabledOffset }) => disabledOffset ? '0px' : '24px'};

  ${({ mediaShowcaseStyles }) => mediaShowcaseStyles ? mediaShowcaseStyles : null};

  @media (max-width: ${LayoutConst.screen.l}px) {
    margin-top: 16px;
  }

  ${({ disabledTabs }) => disabledTabs ? css`
    .action-buttons {
      display: none;
    }
  ` : css`
    .action-buttons {
      margin-top: 0;
    }
  `};
  
  @media (max-width: ${LayoutConst.screen.md}px) {
    align-items: ${({ align }) => align ? align : 'flex-start'};

    ${({ visibleMobileTabs }) => visibleMobileTabs ? css`
      align-items: flex-start;
    ` : null};
  }  
  
  @media (max-width: 834px) {
    flex-direction: column;
    gap: ${({ disableGap, isLMSTeam }) => isLMSTeam ? '24px' : disableGap ? 0 : '24px'};
    align-items: flex-start;

    ${({ disabledTabs, teamButtons }) => disabledTabs ? css`
    .action-buttons {
      display: flex;
      margin-top: ${teamButtons ? '0px' : '0'};
    }
  ` : css`
    .action-buttons {
      margin-top: ${teamButtons ? '0px' : '0'};
    }
  `};

    // .search-bar-wrapper {
    //   place-items: flex-end;
    // }
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    gap: ${({ disableGap }) => disableGap ? 0 : '24px'};
    // margin-top: 16px !important;
  }

  @media(max-width: 430px) {
    ${({ disabledMobOffset, hide }) => disabledMobOffset ? css`
    margin-top: 0;
    ` : hide ? css` display: none` : null}
  }
`

export const AdditionalTitleWrapper = styled.span`
  color: ${Colors.galBlack47};
  margin-left: 32px;
  @media (max-width: ${LayoutConst.screen.sm}px) {
    margin-left: 16px;
  }
`

export const SearchBarBox = styled(FlexBox)<{isTab?: boolean}>`
    ${({ isTab }) => isTab ? css`
      margin-left: auto;
  ` : null};
    @media(max-width: ${LayoutConst.screen.s}px) {
      width: 100%;
      justify-content: flex-end;
    }

`

export const BottomGroupWrapper = styled(FlexBox) <{ titleIsTabs?: boolean, disableOffset?: boolean, disabledTabs?: boolean, disableButtons?: boolean, justifyBetween?: boolean, hasEmblem?: boolean, isAgeytomesh?: boolean, isMedia?: boolean, isCGRave?: boolean, teamButtons?: boolean }>`
  flex-direction: column;
  &:empty {
    display: none;
  }
  max-width: ${({ hasEmblem }) => (hasEmblem) ? '100%' : `calc(100% - ${LayoutConst.projectCard.l.w}px - 24px)`};

   &:not(:first-child) {
     margin-top: 24px;
    //  margin-bottom: 24px;

     @media (max-width: ${LayoutConst.screen.l}px) {
        max-width: 100%;
        margin-top: 16px;
     }
  }

  ${({ hasEmblem }) => hasEmblem ? css`
    justify-content: space-between;
    height: 100%;
  ` : null};

  ${({ disabledTabs, teamButtons }) => disabledTabs ? css`
    .slide-navigation {
      display: none;
    }

    .action-buttons {
      margin-top: ${teamButtons ? '16px' : '0'};
    }
  ` : css`
    .action-buttons {
      margin-top: ${teamButtons ? '16px' : '0'};
    }
  `};

  ${({ disableButtons }) => disableButtons ? css`
    .action-buttons {
      display: none;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
      .action-buttons {
        display: flex;
      }
    }
  ` : null};


  ${({ titleIsTabs }) => titleIsTabs ? css`
    // flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    place-items: baseline;
    ${SearchBarBox} {
      flex-direction: column;
      gap: 12px;
      align-items: flex-end;
      ${TextBarWrapper} {
        margin-right: 0;
      }
    }
    ${DescriptionWrapper} {
      max-width: 858px;
    }

    @media (max-width: ${LayoutConst.screen.l}px) {
      ${DescriptionWrapper} {
        max-width: 714px;
      }
    }

    @media (max-width:  ${LayoutConst.screen.md}px) {
      flex-direction: column;
      ${SearchBarBox} {
        flex-direction: inherit;
        gap: initial;
        align-items: inherit;
        justify-content: space-between;
        ${TextBarWrapper} {
          margin-right: inherit;
        }
      }
      ${DescriptionWrapper} {
        max-width: initial;
      }
      ${OuterWrapper} {
        width: 100%;
      }
    }
    
  `: null}

  @media(max-width: ${LayoutConst.screen.l}px) {
    ${({ isAgeytomesh }) => isAgeytomesh ? css`
      max-width: 700px;
    ` : css`
      max-width: 100%;
    `};
  }

  @media(max-width: ${LayoutConst.screen.m}px) {
    ${({ disabledTabs }) => disabledTabs ? css`
    .slide-navigation {
      display: flex;
    }
  ` : null};

    max-width: ${({ hasEmblem }) => hasEmblem ? '100%' : `100%`};
  }

    ${({ justifyBetween }) => justifyBetween ? css`
      @media(max-width: ${LayoutConst.screen.m}px) {
        justify-content: space-between !important;
        height: 100%;

        .slide-navigation {
          display: none;
        }
      }
    ` : null};
`

export const BrndButtonsWrapper = styled.div`
    display: flex;
    margin-top: 24px;
`

export const ExploreButtonFilled = styled(RectangularButtonFilled) <{
  isGreenBG?: boolean,
  isOrangeBG?: boolean,
  isBlueBG?: boolean,
  isAgeytomesh?: boolean,
  isTeamLG?: boolean,
  customBG?: string,
  disableOffset?: boolean
}>`
  max-width: ${LayoutConst.projectCard.l.w + 'px'};
  min-width: ${LayoutConst.projectCard.l.w + 'px'} !important;
  width: ${LayoutConst.projectCard.l.w + 'px'};
  max-height: 46px;
  white-space: pre;
  // margin-right: ${LayoutConst.projectCardGap.l + 'px'}!important;
  // color: #FEFEFE!important;


  ${({ isTeamLG }) => isTeamLG ? css`
    color: #151514 !important;
  ` : null};

  //Для агейтомеша
  ${({ isGreenBG, isOrangeBG, customBG }) => customBG ? css`background-color: ${customBG} !important;` : isGreenBG ? css`background-color: #151514 !important;` : isOrangeBG ? css`background-color: rgba(231, 87, 40, 1) !important;` : null};

  @media (max-width:  ${LayoutConst.screen.l}px) {
    max-width: ${LayoutConst.projectCard.m.w + 'px'};
    min-width: ${LayoutConst.projectCard.m.w + 'px'} !important;
    width: ${LayoutConst.projectCard.m.w + 'px'};
    // margin-right: ${LayoutConst.projectCardGap.m + 'px'}!important;
  }
  
  @media (max-width:  ${LayoutConst.screen.m}px) {
    max-width: ${LayoutConst.projectCard.s.w + 'px'};
    min-width: ${LayoutConst.projectCard.s.w + 'px'} !important;
    width: ${LayoutConst.projectCard.s.w + 'px'};
    // margin-right: ${LayoutConst.projectCardGap.s + 'px'}!important;

    ${({ isGreenBG, isOrangeBG, customBG }) => customBG ? css`background-color: ${customBG} !important;` : isGreenBG ? css`background-color: #0DC143 !important;` : isOrangeBG ? css`background-color: rgba(231, 87, 40, 1) !important;` : null};

  }
  
  @media (max-width:  ${LayoutConst.screen.s}px) {
    max-width: 145px;
    min-width: 145px!important;
    width: 145px;
  }
`
export const ExploreButtonHollow = styled(RectangularButtonHollow) <{ disableOffset?: boolean }>`
  max-width: ${LayoutConst.projectCard.l.w + 'px'};
  min-width: ${LayoutConst.projectCard.l.w + 'px'} !important;
  width: ${LayoutConst.projectCard.l.w + 'px'};
  max-height: 46px;
  white-space: pre;
  // margin-right: ${LayoutConst.projectCardGap.l + 'px'}!important;

  @media (max-width:  ${LayoutConst.screen.l}px) {
    max-width: ${LayoutConst.projectCard.m.w + 'px'};
    min-width: ${LayoutConst.projectCard.m.w + 'px'} !important;
    width: ${LayoutConst.projectCard.m.w + 'px'};
    // margin-right: ${LayoutConst.projectCardGap.m + 'px'}!important;
  }
  
  @media (max-width:  ${LayoutConst.screen.m}px) {
    max-width: ${LayoutConst.projectCard.s.w + 'px'};
    min-width: ${LayoutConst.projectCard.s.w + 'px'} !important;
    width: ${LayoutConst.projectCard.s.w + 'px'};
    // margin-right: ${LayoutConst.projectCardGap.s + 'px'}!important;
  }
  
  @media (max-width:  ${LayoutConst.screen.s}px) {
    max-width: 145px;
    min-width: 145px!important;
    width: 145px;
  }
`

export const EditChannelButton = styled(ExploreButtonHollow)`
   font-size: 15px!important;
  line-height: 20px!important;
  font-weight: 600!important;
  height: 40px!important;

  @media (max-width:  ${LayoutConst.screen.s}px) {
    max-width: 170px;
    min-width: 170px!important;
    width: 170px;
  }
`

export const AdaptiveTitleContainer = styled(MagicBox) <{ isAgeyTomesh?: boolean, isGeograffee?: boolean, isSuperPuper?: boolean, isGalllleryArt?: boolean }>`
    margin-bottom: 8px;
    text-transform: ${({ isGalllleryArt }) => isGalllleryArt ? 'uppercase' : 'lowercase'};
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 60px;
    line-height: 64px;
    letter-spacing: -0.02em;

    ${({ isGeograffee }) => isGeograffee && css`
      @media (max-width:  ${LayoutConst.screen.m}px) {
      color: #fefefe;
      }
    `};

    ${({ isAgeyTomesh }) => isAgeyTomesh && css`
      text-transform: uppercase;
      font-size: 60px;
      line-height: 64px;
      letter-spacing: 0.53em;
      font-weight: 600;

      @media (max-width:  ${LayoutConst.screen.l}px) {
        font-size: 43px !important;
        line-height: 51px !important;
        letter-spacing: 0.53em !important;
        font-weight: 600 !important;
      }

      @media (max-width: ${LayoutConst.screen.m_1024}px) {
        font-size: 43px !important;
        line-height: 51px !important;
        letter-spacing: 0.53em !important;
        font-weight: 600 !important;
      }

      @media (max-width:  ${LayoutConst.screen.m}px) {
        font-size: 43px !important;
        line-height: 51px !important;
        letter-spacing: 0.30em !important;
        font-weight: 600 !important;
      }

      @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 43px !important;
        line-height: 51px !important;
        letter-spacing: 0.30em !important;
        font-weight: 600 !important;
      }

      @media (max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 28px !important;
        line-height: 34px !important;
        letter-spacing: 0.15em !important;
        font-weight: 600 !important;
      }
    `};
    ${({ isSuperPuper }) => isSuperPuper && css`
      @media (max-width:  ${LayoutConst.screen.m}px) {
          font-size: 43px !important;
          line-height: 51px !important;
          letter-spacing: 1.5px !important;
          font-weight: 600 !important;
          max-width: 350px;
          margin-bottom: 11px;
        }
        `}
    @media (max-width:  ${LayoutConst.screen.l}px) {
      // letter-spacing: 0.53em;
      letter-spacing: -0.02em;
    }

    @media (max-width:  ${LayoutConst.screen.m}px) {
      font-weight: 700;
      font-size: 43px;
      line-height: 51px;
      margin-bottom: 16px;
    }
    @media (max-width:  ${LayoutConst.screen.s}px) { 
      width: 500px; 
      font-size: 43px;
      line-height: 51px;
      letter-spacing: normal !important; 
      margin-bottom: 8px; 
    }

    @media (max-width:  ${LayoutConst.screen.s - 1}px) {
      font-size: 28px;
      line-height: 34px;
      letter-spacing: 4.8px;
      margin-bottom: 8px;
      ${({ isGalllleryArt }) => isGalllleryArt && css`
        letter-spacing: 7.8px !important; 
      `}
    }      
  
    span {
        color: inherit;
    }
`

export const SlideNavigationWrapperItemCustomLink = styled(SlideNavigationWrapperItem) <{ isLMSCourse?: boolean, isTeamLink?: boolean }>`
  // margin-left: 32px;
  min-height: 20px;
  margin-right: ${({ isLMSCourse }) => !isLMSCourse ? '16px !important' : '0px'};
  flex-shrink: 0;

  #tooltip-parent-element , .tooltip-parent-element {
    &::after, &::before {
      display: none !important;
    }
    background: #CDCDCD;
    border-radius: 6px;
    color: #70706F;
  }

  .shop-link-svg {
    height: 20px;
  }
  
  .team-link-svg {
    height: 28px;
    outline: none;
    border: none;
    path {
      transition: fill 0.2s;
    }
    rect {
      transition: stroke 0.2s;
    }

    &:hover {
      path {
        fill: #545453;
        transition: fill 0.2s;
      }
      rect {
        stroke: #545453;
        transition: stroke 0.2s;
      }
    }
  }

  @media (max-width: ${LayoutConst.screen.l}px) {
    padding: 0px;
  }
  
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-left: ${({ isTeamLink }) => isTeamLink ? 0 : '16px'};
    align-items: center;
    margin-bottom: 0;
    padding-bottom: 0;

    .shop-link-svg {
      height: 14px;
    }
  }
  
  @media (max-width: ${LayoutConst.screen.s}px) {
    min-height: unset;
    margin-bottom: ${({ isTeamLink }) => isTeamLink ? 0 : '3px'};
    margin-left: 0;
    padding: 0;
  }
`

export const DesignerLink = styled(Link) <{ isChannel?: boolean }>`
    color: ${Colors.galBlack47};
    cursor: pointer;
    font-family: Inter;
    font-weight: 600;

    ${({ isChannel }) =>
    isChannel &&
    css`
      font-size: 17px;
      line-height: 22px;

      @media (max-width: ${LayoutConst.screen.m}px) {
        font-size: 15px;
        line-height: 20px;
      }
    `}

    &:hover {
        text-decoration: none;
        color: ${(p) => p.theme.projectView.titleColor};
    }
`;


export const BrndTitle = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0;
  font-size: 60px;
  line-height: 70px;
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 50px;
    line-height: 60px;
  }
  @media (max-width: ${LayoutConst.screen.l}px) {
    font-size: 43px;
    line-height: 51px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    font-size: 43px;
    line-height: 51px;
  }
   @media (max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 28px;
            line-height: 34px;
            letter-spacing: -0.56px;
        }
`

export const IFrameGlobal = createGlobalStyle`
  #navbar {
    display: none !important;
  }
  #footer-portal {
    display: none !important;
  }
  #app-content {
    > div {
      display: none;
    }
    padding: 0px;
  }
  #map-frame-wrapper {
    height: 100%;
  }
  
`

export const Outer = styled(CoreContainer) <{ isCompetition?: boolean, minOffset?: boolean, isHse?: boolean }>`
  position: relative;
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: ${({ minOffset }) => minOffset ? 0 : '20px'};
    padding-left: 10px;
    padding-right: 10px;
  }

  ${({ isCompetition, minOffset }) => isCompetition ? css`
    @media(max-width: ${LayoutConst.screen.md}px) {
      .target-icon-wrapper {
        * {
          color: #fefefe;
          font-weight: 500;
        }
      }
    }
    @media(max-width: ${LayoutConst.screen.s}px) {
      margin-top: ${minOffset ? 0 : '16px'};
    }
  ` : null};



`;

export const GlobalChangeColorWrapper = createGlobalStyle`
  .app-wrapper {
    background-color: #E7E7E7!important;
  }
`

export const Title = styled(FInter.MainTitleMediumDiv)`
  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 36px;
    line-height: 39px;
  }
`;

export const MobileFilterRow = styled.div<{ fixed?: boolean, importantWidth?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  ${(p) =>
          p?.fixed ? css`
            position: sticky;
            top: 48px;
            left: 0;
            width: auto;
            z-index: 99;
            background-color: ${p => p.theme.app.backgroundColor};
          ` : null}

  ${p => p.importantWidth ? css`
    width: 100%;
  ` : css`
    .ExploreViewInnerSearchTags {
      width: calc(100% - 100px);
    }
  `};
  @media (max-width: 743px) {
    width: 100%;
  }
`;

export const MobileFilterSort = styled.div<{isLectureMedia?: boolean}>`
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: #909090;
  display: flex;
  align-items: center;

  ${({isLectureMedia}) => isLectureMedia && css`
    width: 145px;
    justify-content: flex-end;
  `}


  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 15px;
    line-height: 20px;
    margin-left: auto;
    align-self: flex-start;
    margin-right: 10px;
  }
`;